import React from "react";
import logo from "../Assets/black-logo.png";
import { Link } from "react-router-dom";

function SignUp() {
  return (
    <div className="m-auto px-4 py-8 sm:px-24 md:px-40 lg:w-[50rem]">
      <img src={logo} alt="logo" className="h-12 lg:h-20 block m-auto" />

      <h1 className="text-center py-5 font-bold text-2xl mb-3">
        Sign up for free to start listening.
      </h1>

      <div className="grid gap-3">
        <button className="bg-blue-800 text-white px-3 py-3 sm:py-3 md:py-3 rounded-3xl text-sm font-bold hover:transform translate duration-800 hover:scale-105 hover:bg-blue-900">
          <span className="space-x-2 flex justify-center items-center">
            <ion-icon name="logo-facebook"></ion-icon>
            <Link to="#">Sign up with with facebook</Link>
          </span>
        </button>
        <button className="px-5 py-3 sm:py-3 md:py-3 rounded-3xl text-sm font-bold border-2 border-gray-600 hover:transform translate duration-800 hover:scale-105">
          <span className="space-x-2 flex justify-center items-center">
            <ion-icon name="logo-google"></ion-icon>
            <Link to="#">Sign up with Google</Link>
          </span>
        </button>
      </div>
      <div className="p-5 ">
        <fieldset className="border-t border-slate-300">
          <legend className="mx-auto px-3 font-medium">or</legend>
        </fieldset>
      </div>

      <form className="flex flex-col gap-y-7">
        <div>
          <label
            className="block font-bold text-sm mb-1"
            for="inline-full-name"
          >
            Email or username
          </label>
          <div className="mt-2">
            <input
              placeholder="Email or username"
              className="py-2 px-4 w-full font-bold text-sm placeholder:text-gray-700 rounded appearance-none border-[1px] border-gray-400 focus:border-0"
            />
          </div>
          <Link
            to="#"
            className="cursor-pointer underline text-green-800 text-sm"
          >
            Use phone number instead
          </Link>
        </div>

        <div>
          <label
            className="block font-bold text-sm mb-1"
            htmlFor="inline-full-name"
          >
            Confirm your email
          </label>
          <div className="mt-2">
            <input
              placeholder="Confirm your email"
              className="py-2 px-4 w-full font-semibold placeholder:text-gray-700 rounded appearance-none border-[1px] border-gray-400"
            />
          </div>
        </div>

        <div>
          <label
            className="block font-bold text-sm mb-1"
            htmlFor="inline-full-name"
          >
            Create a password
          </label>
          <div className="mt-2">
            <input
              placeholder="Create a password"
              className="py-2 px-4 w-full font-semibold placeholder:text-gray-700 rounded appearance-none border-[1px] border-gray-400"
            />
          </div>
        </div>

        <div>
          <label
            className="block font-bold text-sm mb-1"
            htmlFor="inline-full-name"
          >
            What should we call you?
          </label>
          <div className="mt-2">
            <input
              placeholder="Enter a profile name"
              className="py-2 px-4 w-full font-semibold placeholder:text-gray-700 rounded appearance-none border-[1px] border-gray-400"
            />
          </div>
          <p to="#" className="text-sm">
            This appears on your profile.
          </p>
        </div>

        <div className="w-full">
          <label
            className="block font-bold text-sm mb-1"
            htmlFor="inline-full-name"
          >
            What is your date of birth?
          </label>

          <div className="flex justify-between items-center">
            <div className="">
              <label className="block font-medium text-sm mb-1">Day</label>
              <input
                type="text"
                placeholder="DD"
                className="py-2 px-2 w-14 font-semibold placeholder:text-gray-700 rounded appearance-none border-[1px] border-gray-400"
              />
            </div>

            <div className="">
              <label htmlFor="months" className="block font-medium text-sm mb-1">
                Month
              </label>
              <select
                id="months"
                name="months"
                className="p-2 w-28 rounded border-[1px] border-gray-400"
              >
                <option value="month">Month</option>
                <option value="month">Jan</option>
                <option value="saab">Feb</option>
                <option value="fiat">March</option>
                <option value="audi">APril</option>
              </select>
            </div>

            <div className="">
              <label className="block font-medium text-sm mb-1">Day</label>

              <input
                type="text"
                placeholder="YY"
                className="p-2 w-20 font-semibold placeholder:text-gray-700 rounded appearance-none border-[1px] border-gray-400"
              />
            </div>
          </div>
        </div>
        <div>
          <label
            className="block font-bold text-sm mb-2"
            htmlFor="inline-full-name"
          >
            What is your gender?
          </label>

          <div className="flex justify-between">
            <label className="flex items-center">
              <input
                className="mr-2 leading-tight accent-green-400"
                type="radio"
              />
              <span class="font-medium text-sm">Male</span>
            </label>
            <label className="flex items-center">
              <input
                className="mr-2 leading-tight accent-green-400"
                type="radio"
              />
              <span className="font-medium text-sm">Female</span>
            </label>
            <label className="flex items-center">
              <input
                className="mr-2 leading-tight accent-green-400"
                type="radio"
              />
              <span className="font-medium text-sm">Prefer not to say</span>
            </label>
          </div>
        </div>

        <div className="grid grid-rows-2 gap-y-8">
          <div>
            <label>
              <input
                className="mr-2 leading-tight accent-green-400"
                type="checkbox"
              />
              <span className="font-medium text-sm">
                I would prefer not to receive marketing messages from Spotify
              </span>
            </label>
          </div>

          <div>
            <label>
              <input
                className="mr-2 leading-tight accent-green-400"
                type="checkbox"
              />
              <span className="font-medium text-sm">
                Share my registration data with Spotify's content providers for
                marketing purposes.
              </span>
            </label>
          </div>
        </div>
        <div>
          <p className="text-[.6rem] font-medium text-center">
            By clicking on sign-up, you agree to the
            <span className="text-green-500 cursor-pointer hover:text-green-400 mx-1">
              Spotify Terms and Conditions
            </span>
            and
            <span className="text-green-500 cursor-pointer hover:text-green-400 ml-1">
              Privacy Policy.
            </span>
          </p>
        </div>

        <button
          type="submit"
          className="block m-auto bg-green-500 px-12 py-4 lg:py-3 rounded-full text-sm font-bold uppercase hover:transform translate duration-800 hover:scale-110 hover:bg-green-400"
        >
          <Link to="/signup">sign up</Link>
        </button>

        <h1 className="text-center text-sm font-medium">
          Have an account?
          <span className="text-green-500 cursor-pointer hover:text-green-400 mx-1">
          <Link to="/login">Log in.</Link>
          </span>
        </h1>
      </form>
    </div>
  );
}

export default SignUp;
